import React, { useState, Fragment } from "react";
import Popover from "@material-ui/core/Popover";
import Delete from "@material-ui/icons/Delete";
import FileCopy from "@material-ui/icons/FileCopy";
import Grid from "@material-ui/core/Grid";
import Edit from "@material-ui/icons/Edit";
import Settings from "@material-ui/icons/Settings";
import ButtonBase from "@material-ui/core/ButtonBase";
import Typography from "@material-ui/core/Typography";
import Tooltip from '@material-ui/core/Tooltip';
import { useSelector, useDispatch } from "react-redux";
import { getSelectedNode } from "../../../../store/global/selectors";
import { getClusterlets, getConstructs } from "../../../../store/constructs/clusterlets/selectors";
import { getSections } from "../../../../store/constructs/sections/selectors";
import { getFields } from "../../../../store/constructs/fields/selectors";
import { getAllTransactions } from "../../../../store/constructs/transactions/selectors";
import { getAllEvents } from "../../../../store/constructs/events/selectors";
import { getClusterletConnections } from "../../../../store/constructs/clusterlet_connections/selectors";
import { getInstances } from "../../../../store/constructs/bootloaders/selectors";
import DeleteClusterletAlert from "../../alerts/DeleteClusterletAlert";
import {
	profileData,
	generateConnection,
	addProfileIdToClusterlet,
	toClusterletForamtInStoreOnClone,
	toInstanceData
} from "../../../../services/reactFlowService";

import {
	onNodeClick,
	addClusterlet,
	editClusterlet,
	deleteClusterlet,
	checkClusterletInTransactions,
	cloneClusterlet,
	deleteNodeAndAssociates
} from "../../../../store/constructs/clusterlets/actions";

import { addClusterletConnection } from "../../../../store/constructs/clusterlet_connections/actions";
import { addInstance, deleteInstance } from "../../../../store/constructs/bootloaders/actions";
import { dealWithClusterlets } from "../../../../store/undoredo/actions";
import Dialog from "../../../atoms/dialog";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import { validateLabel, LabelHelperText, checkNameExist } from "./helpers";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";

export default function SimplePopover() {
	const dispatch = useDispatch();
	const { anchorEl, data, ...rest } = useSelector(getSelectedNode);
	const clusterlets = useSelector(getClusterlets);
	const history = useHistory();
	const [deleteDialog, setDeleteDialog] = useState(false);
	const [dialogOpen, setDialogOpen] = useState(false);
	const onDialogClose = () => setDialogOpen(null);
	const toggleDeleteDialog = () => setDeleteDialog((prev) => !prev);
	const { register, control, getValues, reset, trigger, errors } = useForm();


	const handleClose = () => {
		dispatch(onNodeClick(null, null));
	};

	const onClone = () => {
		setDialogOpen(true);
	};

	const onEdit = () => {
		handleClose();

		const [, , blueprintname] = window.location.pathname.split("/");

		history.push(`/blueprint/${blueprintname}/${data.type}?selected=${data.id}`);
	};

	const onSettingsAdd = async () => {
		handleClose();
		console.log('settings----------->')

		const profile = await profileData("profile", data, clusterlets)
		// console.log("profile", {profile, data})
		await dispatch(addClusterlet(profile, true))

		const connectionString = await generateConnection(data, profile)
		// console.log("connectionString", connectionString)

		await dispatch(addClusterletConnection(connectionString, true))

		//adding the profile id to clusterlet
		const editedClusterlet = addProfileIdToClusterlet(data.id, profile.id, clusterlets)
		dispatch(editClusterlet(editedClusterlet, true));

		const instanceData = toInstanceData(profile)
		// console.log("instance data", instanceData)
		dispatch(addInstance(instanceData, true));

		//deal with clusterlet for undoredo
		const payload = profile
		dispatch(dealWithClusterlets(payload, 'add'))

	};

	const onCompletion = () => {
		/**delete the node options popover*/
		handleClose();
	}

	const onActionComplete = () => {
		trigger().then(async (isValid) => {
			if (!isValid) return;
			const { title } = getValues();
			const cloneNameExists = checkNameExist(title, clusterlets)
			if (cloneNameExists) {
				return
			}

			const selectedNode = clusterlets.find(clusterlet => clusterlet.id === data.id)

			await dispatch(cloneClusterlet({ selectedNode, name: title }))

			handleClose();
			onDialogClose();
		});
	};

	const isConnectionString = false
	const open = Boolean(anchorEl) || isConnectionString;
	const id = open ? "simple-node-options-popover" : undefined;
	const noClone = (data && data.type === "profile") || (data && data.type === "sensor");
	const deleteCondition =
		(data && data.type === "clusterlet") ||
		(data && data.type === "profile") ||
		(data && data.type === "external_function") ||
		(data && data.type === "analytics") ||
		(data && data.type === "sensor");

	let profileAlreadyAdded = false
	const selectedClusterlet = clusterlets.find(clusterlet => clusterlet.id === data?.id)
	if (selectedClusterlet?.profile?.length > 0) profileAlreadyAdded = true
	const addProfileCondition = (data?.type === 'clusterlet' || data?.type === 'analytics') && profileAlreadyAdded === false


	return (
		<div>
			<Popover
				id={id}
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<Grid container direction="row">
					{/* {!noEdit && ( */}
					<ButtonBase onClick={onEdit} style={{ padding: 3, marginRight: 5 }}>
						<Tooltip title="Edit">
							<Edit color="primary" title="Edit" />
						</Tooltip>
					</ButtonBase>
					{/* )} */}

					{!noClone && (
						<React.Fragment>
							{dialogOpen && (
								<Dialog
									title={"Clone!"}
									handleClose={onDialogClose}
									open={dialogOpen}
									actions={
										<>
											<Button onClick={onDialogClose} color="primary" variant="outlined" style={{ marginLeft: 10 }}>
												Cancel
											</Button>
											<Button onClick={onActionComplete} color="primary" variant="contained" style={{ marginLeft: 10 }}>
												Clone
											</Button>
										</>
									}
								>
									<TextField
										InputLabelProps={{
											shrink: true,
										}}
										fullWidth
										required
										label={"Name"}
										placeholder={"Name"}
										variant="outlined"
										name="title"
										error={Boolean(errors.title)}
										helperText={<LabelHelperText control={control} elementTag={"clusterlet"} />}
										inputRef={register({
											required: true,
											validate: validateLabel
										})}
									/>
								</Dialog>
							)}
							<ButtonBase style={{ padding: 3, marginRight: 5 }} onClick={onClone}>
								<Tooltip title="Clone">
									<FileCopy />
								</Tooltip>
							</ButtonBase>
						</React.Fragment>
					)}
					{deleteCondition && (
						<ButtonBase style={{ padding: 3 }} onClick={toggleDeleteDialog}>
							<Tooltip title="Delete">
								<Delete color="error" />
							</Tooltip>
						</ButtonBase>
					)}

					{addProfileCondition && (
						<ButtonBase style={{ padding: 3, marginRight: 5 }} onClick={onSettingsAdd}>
							<Tooltip title="Add Profile">
								<Settings />
							</Tooltip>
						</ButtonBase>
					)}

					{isConnectionString && (
						<ButtonBase style={{ padding: 3 }} onClick={toggleDeleteDialog}>
							<Delete color="error" />
						</ButtonBase>
					)}

				</Grid>
			</Popover>
			{deleteDialog && <DeleteClusterletAlert onClose={toggleDeleteDialog} id={data.id} onCompletion={onCompletion} />}
			{/* {deleteDialog && <DeleteDialog open={deleteDialog} handleClose={toggleDeleteDialog} closePopover={handleClose} data={data} data={data} />} */}
		</div>
	);
}

const DeleteDialog = ({ open, handleClose, closePopover, data: { type, data: { label } = {}, ...rest } = {}, data, }) => {

	const clusterletsInStore = useSelector(getClusterlets)
	const clusterletConnections = useSelector(getClusterletConnections)
	const transactions = useSelector(getAllTransactions);
	const events = useSelector(getAllEvents);
	const sections = useSelector(getSections);
	const fields = useSelector(getFields);
	const instances = useSelector(getInstances);
	const constructs = useSelector(getConstructs);
	const dispatch = useDispatch();
	let checkSelectedNodIncludedInTransaction = "";


	const clusterletInTransation = checkClusterletInTransactions({ id: data.id, transactions })
	if (clusterletInTransation.length > 0) {
		checkSelectedNodIncludedInTransaction =
			`The selected node ${label} is used in the transaction ${clusterletInTransation[0]}.`
	}

	const onActionComplete = async () => {
		handleClose();
		closePopover();

		const deleteElement = clusterletsInStore.find(i => i.id === data.id)
		await dispatch(deleteNodeAndAssociates({ node: deleteElement }))

	};

	return (
		<Dialog
			title={"Delete!"}
			handleClose={handleClose}
			open={open}
			actions={
				<>
					<Button
						onClick={handleClose}
						color="primary"
						variant="outlined"
						style={{ marginLeft: 10 }}
					>
						Cancel
					</Button>
					<Button
						onClick={onActionComplete}
						color="secondary"
						variant="contained"
						style={{ marginLeft: 10 }}
					>
						Delete
					</Button>
				</>
			}
		>
			<Fragment>
				Are you sure you want to delete this node?
			</Fragment>

			{clusterletInTransation.length > 0 && (
				<Fragment>
					<Typography>{checkSelectedNodIncludedInTransaction}</Typography>
				</Fragment>
			)}
		</Dialog>
	);
};
